<!-- Backdrop -->
<div class="no-print fixed inset-0 z-[55] bg-neutral-950/50 backdrop-blur-[2px]" (click)="closed.emit()"></div>

<!-- Slide-over -->
<aside class="no-print fixed inset-y-0 right-0 z-[56] w-full max-w-[600px] bg-gray-50 shadow-2xl flex flex-col" role="dialog" aria-label="Abandoned carts">

  <!-- Header -->
  <div class="text-white px-6 pt-5 pb-5 flex-shrink-0 bg-gradient-to-br from-violet-900 to-neutral-800">
    <div class="flex items-start justify-between gap-3">
      <div>
        <h2 class="text-xl font-bold tracking-tight">Abandoned carts</h2>
        <p class="text-sm text-neutral-300 mt-0.5">Shoppers who reached checkout on the website and left their details, but didn't order</p>
      </div>
      <button class="h-9 w-9 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center flex-shrink-0" (click)="closed.emit()" aria-label="Close"><mat-icon>close</mat-icon></button>
    </div>
    @if (totals) {
    <div class="grid grid-cols-4 gap-2 mt-4">
      <div class="rounded-xl bg-white/10 px-3 py-2"><div class="text-xl font-bold leading-tight">{{ totals.count | number }}</div><div class="text-[10px] uppercase tracking-wider text-neutral-300">Shoppers</div></div>
      <div class="rounded-xl bg-white/10 px-3 py-2"><div class="text-xl font-bold leading-tight text-amber-300">£{{ totals.value | number:'1.0-0' }}</div><div class="text-[10px] uppercase tracking-wider text-neutral-300">In baskets</div></div>
      <div class="rounded-xl bg-white/10 px-3 py-2"><div class="text-xl font-bold leading-tight">{{ totals.returning | number }}</div><div class="text-[10px] uppercase tracking-wider text-neutral-300" title="Have ordered from us before">Returning</div></div>
      <div class="rounded-xl bg-white/10 px-3 py-2"><div class="text-xl font-bold leading-tight">{{ totals.notContacted | number }}</div><div class="text-[10px] uppercase tracking-wider text-neutral-300">Not called</div></div>
    </div>
    }
  </div>

  <!-- Filters -->
  <div class="bg-white border-b border-gray-200 px-6 py-3 flex flex-col gap-3 flex-shrink-0">
    <div class="relative">
      <mat-icon class="absolute left-3 top-1/2 -translate-y-1/2 !text-gray-400 !text-[18px] !h-[18px] !w-[18px] pointer-events-none">search</mat-icon>
      <input type="text" placeholder="Search name, email, phone or postcode"
        class="w-full pl-10 pr-3 py-2.5 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-100 outline-none text-sm"
        [(ngModel)]="search" (ngModelChange)="onSearch()" />
    </div>
    <div class="flex items-center gap-2 flex-wrap">
      <div class="inline-flex rounded-lg bg-gray-100 p-0.5">
        @for (d of windows; track d) {
        <button class="px-2.5 py-1 rounded-md text-xs font-semibold transition-all" [class]="days === d ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-800'" (click)="setDays(d)">{{ windowLabel(d) }}</button>
        }
      </div>
      <div class="inline-flex rounded-lg bg-gray-100 p-0.5">
        <button class="px-2.5 py-1 rounded-md text-xs font-semibold transition-all" [class]="sort === 'recent' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-800'" (click)="setSort('recent')">Newest</button>
        <button class="px-2.5 py-1 rounded-md text-xs font-semibold transition-all" [class]="sort === 'value' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-800'" (click)="setSort('value')">Biggest</button>
      </div>
      <div class="inline-flex rounded-lg bg-gray-100 p-0.5">
        <button class="px-2.5 py-1 rounded-md text-xs font-semibold transition-all" [class]="contacted === 'NO' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-800'" (click)="setContacted('NO')">
          Not called yet @if (totals) { <span class="ml-1 text-[10px] rounded-full px-1.5 bg-amber-100 text-amber-800">{{ totals.notContacted }}</span> }
        </button>
        <button class="px-2.5 py-1 rounded-md text-xs font-semibold transition-all" [class]="contacted === 'YES' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-800'" (click)="setContacted('YES')">Followed up</button>
        <button class="px-2.5 py-1 rounded-md text-xs font-semibold transition-all" [class]="contacted === 'ALL' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-800'" (click)="setContacted('ALL')">Both</button>
      </div>
      <button class="ml-auto flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-white border border-gray-200 text-gray-700 text-xs font-semibold hover:border-amber-300 hover:bg-amber-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        [disabled]="exporting || !count" (click)="exportToExcel()" matTooltip="Export the filtered list to Excel">
        @if (exporting) {
        <span class="inline-block h-3.5 w-3.5 rounded-full border-2 border-gray-400 border-t-transparent animate-spin"></span>
        } @else {
        <mat-icon class="!text-[16px] !h-4 !w-4">download</mat-icon>
        }
        Export
      </button>
    </div>
  </div>

  <!-- List -->
  <div class="flex-1 overflow-y-auto px-6 py-4">
    @if (loading) {
      <div class="h-64 flex flex-col items-center justify-center"><mat-spinner diameter="30"></mat-spinner><div class="text-sm text-gray-500 mt-3">Finding shoppers&hellip;</div></div>
    } @else if (loadError) {
      <div class="bg-red-50 border border-red-200 text-red-700 rounded-2xl p-4 text-sm flex items-center justify-between"><span>Could not load abandoned carts.</span><button class="text-xs uppercase font-semibold underline" (click)="load(true)">Try again</button></div>
    } @else if (items.length === 0) {
      <div class="h-64 flex flex-col items-center justify-center text-center">
        <span class="h-14 w-14 rounded-2xl bg-emerald-50 flex items-center justify-center mb-3"><mat-icon class="!text-emerald-500 !text-[30px] !h-[30px] !w-[30px]">verified</mat-icon></span>
        <div class="text-lg font-semibold text-gray-800">Nobody to chase here</div>
        <div class="text-sm text-gray-500 mt-1">No abandoned carts match these filters in the last {{ days }} day{{ days === 1 ? '' : 's' }}.</div>
      </div>
    } @else {
      <div class="flex flex-col gap-3">
        @for (c of items; track c.cartId) {
        <div class="bg-white rounded-2xl border border-gray-100 shadow-sm p-4">

          <div class="flex items-start justify-between gap-3">
            <div class="min-w-0">
              <div class="flex items-center gap-2 flex-wrap">
                <span class="font-bold text-gray-900 truncate">{{ displayName(c) }}</span>
                @if (c.account?.trade) { <span class="text-[10px] font-semibold px-2 py-0.5 rounded-full bg-indigo-50 text-indigo-700">Trade</span> }
                @if (c.account && c.account.orders > 0) {
                  <span class="text-[10px] font-semibold px-2 py-0.5 rounded-full bg-emerald-50 text-emerald-700" [matTooltip]="'£' + (c.account.spent | number:'1.0-0') + ' spent with us'">Bought {{ c.account.orders }}× before</span>
                } @else if (c.account) {
                  <span class="text-[10px] font-semibold px-2 py-0.5 rounded-full bg-sky-50 text-sky-700">Has an account</span>
                } @else {
                  <span class="text-[10px] font-semibold px-2 py-0.5 rounded-full bg-gray-100 text-gray-600">New shopper</span>
                }
              </div>
              @if (c.account?.company && c.account?.company !== c.customer.name) { <div class="text-xs text-gray-500">{{ c.account?.company }}</div> }
            </div>
            <div class="text-right flex-shrink-0">
              <div class="text-lg font-bold text-gray-900 leading-tight">£{{ c.value | number:'1.0-0' }}</div>
              @if (isHot(c)) { <span class="text-[10px] font-semibold px-2 py-0.5 rounded-full bg-orange-100 text-orange-800" matTooltip="Left in the last 24 hours - the best time to call">Call now</span> }
            </div>
          </div>

          <div class="mt-2 text-xs text-gray-500 flex items-center gap-1.5 flex-wrap">
            <span>Last at checkout {{ c.updatedAt | date:'d MMM, HH:mm' }} ({{ ago(c.updatedAt) }})</span>
            @if (c.customer.postCode) { <span>·</span><span>{{ c.customer.postCode }}</span> }
          </div>

          @if (c.items.length) {
          <div class="mt-2 flex flex-col gap-1">
            @for (i of c.items; track $index) {
            <div class="flex items-center gap-2 text-xs">
              @if (i.image) { <img [src]="i.image" alt="" class="h-7 w-7 rounded-md object-cover bg-gray-100 flex-shrink-0" loading="lazy" /> }
              @else { <span class="h-7 w-7 rounded-md bg-gray-100 flex-shrink-0"></span> }
              <span class="text-gray-700 truncate flex-1">{{ i.name }}</span>
              <span class="text-gray-400 flex-shrink-0">{{ i.quantity }} × £{{ i.unitPrice | number:'1.2-2' }}</span>
            </div>
            }
            @if (c.itemCount > c.items.length) { <span class="text-[11px] text-gray-400 pl-9">+{{ c.itemCount - c.items.length }} more</span> }
          </div>
          }

          @if (c.lastFollowUp) {
          <div class="mt-3 rounded-xl bg-amber-50 border border-amber-100 px-3 py-2 text-xs text-amber-900">
            <div class="font-semibold">Followed up {{ ago(c.lastFollowUpDate) }} by {{ c.lastFollowUpBy || 'someone' }}</div>
            <div class="mt-0.5">{{ c.lastFollowUp }}</div>
          </div>
          }

          <!-- Reach them -->
          <div class="mt-3 flex items-center gap-1.5 flex-wrap">
            @if (c.customer.phone) {
            <a class="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-emerald-600 text-white text-xs font-semibold hover:bg-emerald-700 transition-colors" [href]="'tel:' + c.customer.phone"><mat-icon class="!text-[16px] !h-4 !w-4">call</mat-icon> {{ c.customer.phone }}</a>
            <a class="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-green-50 text-green-700 border border-green-200 text-xs font-semibold hover:bg-green-100 transition-colors" [href]="waLink(c.customer.phone, c)" target="_blank" rel="noopener"><mat-icon class="!text-[16px] !h-4 !w-4">chat</mat-icon> WhatsApp</a>
            }
            @if (c.customer.email) {
            <a class="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-sky-50 text-sky-700 border border-sky-200 text-xs font-semibold hover:bg-sky-100 transition-colors" [href]="mailLink(c)"><mat-icon class="!text-[16px] !h-4 !w-4">mail</mat-icon> Email</a>
            <button class="h-8 w-8 rounded-lg text-gray-400 hover:bg-gray-100 hover:text-gray-700 flex items-center justify-center" (click)="copy(c.customer.email)" matTooltip="Copy email"><mat-icon class="!text-[16px] !h-4 !w-4">content_copy</mat-icon></button>
            }
            <span class="flex-1"></span>
            <button class="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-white border border-gray-200 text-gray-700 text-xs font-semibold hover:border-amber-300 hover:bg-amber-50 transition-colors" (click)="toggleNote(c)"><mat-icon class="!text-[16px] !h-4 !w-4">edit_note</mat-icon> Log follow-up</button>
            <button class="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-gradient-to-b from-amber-400 to-amber-500 text-neutral-900 text-xs font-bold hover:from-amber-300 hover:to-amber-400 transition-all disabled:opacity-50"
              [disabled]="c.starting" (click)="startSale(c)" matTooltip="Open a new sale with this basket at today's prices">
              <mat-icon class="!text-[16px] !h-4 !w-4">add_shopping_cart</mat-icon> {{ c.starting ? 'Loading' : 'Start sale' }}
            </button>
          </div>

          @if (c.noteOpen) {
          <div class="mt-3 flex items-start gap-2">
            <textarea rows="2" class="flex-1 px-3 py-2 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-100 outline-none text-sm resize-none"
              placeholder="What happened? e.g. Called, wants delivery after the 20th" [(ngModel)]="c.noteText"></textarea>
            <button class="px-4 py-2 rounded-xl bg-gradient-to-b from-amber-400 to-amber-500 text-neutral-900 text-sm font-bold hover:from-amber-300 hover:to-amber-400 transition-all disabled:opacity-50" [disabled]="c.noteSaving || !(c.noteText || '').trim()" (click)="saveNote(c)">{{ c.noteSaving ? 'Saving' : 'Save' }}</button>
          </div>
          }
        </div>
        }

        @if (hasMore) {
        <button class="mx-auto mt-1 px-5 py-2.5 rounded-xl bg-white border border-gray-200 text-sm font-semibold text-gray-700 hover:border-amber-300 hover:bg-amber-50 transition-colors" [disabled]="loadingMore" (click)="loadMore()">
          {{ loadingMore ? 'Loading...' : 'Show more (' + (count - items.length) + ' left)' }}
        </button>
        }
      </div>
    }
  </div>
</aside>
